import { useSelector } from 'react-redux'
export const useHousing = () => {
  const signedIn = useSelector(state => state.identity.signedIn)

  return {
    signedIn,
  }
}
